import { z } from 'zod';
/**
 * Required SSN - must be exactly 9 numeric characters.
 *
 * Check order is deliberate: resolvers surface only the first issue per field, so `.trim()`
 * and `.regex()` must precede `.length()`. Covered by `ssn.test.ts`.
 */
export const ssnSchema = (requiredMessage = 'Required') => z
    .string({ message: requiredMessage })
    .trim()
    .min(1, requiredMessage)
    .regex(/^\d+$/, 'Only numeric characters are allowed')
    .length(9, 'SSN must be 9 digits');
